import { render, staticRenderFns } from "./AnnualCatalogDetails.vue?vue&type=template&id=6a90023f"
import script from "./AnnualCatalogDetails.vue?vue&type=script&lang=js"
export * from "./AnnualCatalogDetails.vue?vue&type=script&lang=js"
import style0 from "./AnnualCatalogDetails.vue?vue&type=style&index=0&id=6a90023f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports